let miss = [{ module: 1, key: 4 }];

const allTips = [
  [
    {
      content:
        '<h3>Developmental Tip: Child-Centered Time - 1</h3>Child-centered time works great even if your child is not using words. Choose 3-4 activities or toys and show them to your child. Your child may choose their activity by pointing, looking, or simply starting to play. As your child plays, follow their lead and join in the play.',
      id: 1,
      clicked: false,
      title: 'Child-Centered Time - 1',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Descriptive Commenting</h3><p> Using descriptive commenting to describe aloud what your child is doing builds language skills and helps keep them engaged. </p>',
      id: 2,
      clicked: false,
      title: 'Descriptive Commenting',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Child-Centered Time - 2</h3><h4>Here are some ideas of child-centered activities for younger children: </h4><ul> <li>Physical games like hide-and-seek and peek-a-boo</li> <li>Bath time with toys and cups </li> <li>Playing with blocks (stacking, sorting, building), shape-sorters and puzzles </li> <li>Playing with bubbles or chalk </li> <li>Coloring with large crayons and markers that are easy to grip </li> <li>Playing pretend play with dolls or stuffed animals (e.g.., feeding, bathing, putting them to sleep, throwing them a party) </li></ul><p>For children who are not using words, pay extra attention to how you join in the play activity and give your child your full attention. Your eye contact and smiles are important ways to tell your child that you are paying attention to them. Do your best to keep the phones and tablets away during this time.</p>',
      id: 3,
      clicked: false,
      title: 'Child-Centered Time - 2',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Routines - 1</h3>If your child receives early intervention therapies like physical (PT), occupational (OT) or speech (ST) therapy, combining therapy exercises with routines like songs or games can help your child feel more comfortable and know what to expect during these activities.',
      id: 4,
      clicked: false,
      title: 'Developmental Tip: Routines - 1',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Routines - 2</h3>It’s never too early or too late to start a family routine, like eating meals together. Even if you all eat different foods, sitting together and putting away phones and tablets helps everyone pay attention to each other. This helps children feel safe, loved, and important in the family.',
      id: 5,
      clicked: false,
      title: 'Routines - 2',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Reading with Young Children</h3><p>It’s never too early to start reading to your child! Even if your child is not using words, reading is an important routine to build your child’s brain. Here are some ideas to make reading enjoyable:</p>  <ul><li>Sing the story to your child. Young children love to hear their parents sing</li><li>Read books with flaps, mirrors, fabric pages or pages that crinkle. Children  enjoy the sensations that come along with these types of books</li><li>Read before nap or bedtime when your child might have an easier time sitting still and cuddling </li> <li>Get cozy! Read in a comfortable spot in the house with blankets and pillows</li><li>Look at pictures and describe them! Young children (under the age of 2) are more interested in photographs than cartoons. You can name or describe the things or actions in the photographs or make up a story about the picture.</li></ul>',
      id: 6,
      clicked: false,
      title: 'Reading with Young Children',
      missed: false,
    },
  ],
  [
    {
      content:
        '<h3>Developmental Tip: Labeled Praise - 1</h3>If your child is not yet speaking or speaking in sentences less than 3 words, keep it simple! Use short sentences, “Great job sharing” or “I like when you help me clean up!” Combine the praise with a hug, big smile, or high-five to reinforce the praise!',
      id: 1,
      clicked: false,
      title: 'Labeled Praise - 1',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Labeled Praise - 2</h3>Use labeled praise to help your child learn new skills. When you see your child trying something that is developmentally new or hard for them, point it out by using labeled praise. For example, your child is learning to go up and down the stairs on their own, you can say, “Good job holding the railing!”.',
      id: 2,
      clicked: false,
      title: 'Labeled Praise - 2',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Reward Programs</h3><p>Make sure your child is able to understand your reward program! Make it simple and achievable. Also, make sure they are developmentally ready to use rewards, these include milestones like:</p><ul><li>Your child speaks in 2-3 word sentences</li><li>Your child can follow a 2-step instruction, for example, “Get your socks and come to the kitchen.”</li></ul><p>If your child is not ready for rewards, keep using labeled praise and your time and attention to see more of the behaviors that you want to see!</p>',
      id: 3,
      title: 'Reward Programs',
      missed: false,
    },
  ],
  [
    {
      content:
        '<h3>Developmental Tip: <i>DO</i> Statements</h3>Depending on your child’s age and abilities, they may need help following your <i>DO</i> statement and that’s ok! Helping them follow it gives them a sense of success and teaches them what to do and how to do it.',
      id: 1,
      clicked: false,
      title: 'DO Statements',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Question Commands</h3>When children are developing their language, question commands can be extra confusing! They are not likely to understand that your questions are sometimes meant as directions to be followed.',
      id: 2,
      clicked: false,
      title: 'Question Commands',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Warning Statements</h3>Many young children don’t yet understand the concept of time. Warning statements that involve counting or numbers of activities can help many young children know what to expect next. For example, “I’m going to count to 10 and then we are going to start cleaning up the toys” OR “You can go down the slide one more time and then we are leaving the park.”',
      id: 3,
      clicked: false,
      title: 'Warning Statements',
      missed: false,
    },
  ],
  [
    {
      content:
        '<h3>Developmental Tip: Natural <i>If/Then</i> Statements</h3>To help children understand natural <i>if/then</i> statements, say the <i>if/then</i> clearly and guide them toward the wanted choice. For example, if a child squeezes a juice box too hard, it might spill, so you can help them hold it correctly. If a child doesn’t yet understand ideas like size, color, or location <i>(on top, underneath)</i>, they will need extra support. Natural <i>if/then</i> statements help children learn how their actions lead to outcomes they may not like.',
      id: 1,
      clicked: false,
      title: 'Natural If/Then Statements',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Logical If/Then</i> Statements</h3>Logical <i>if/then</i> statements should <u>NOT</u> be used with children less than 2 years old because children that young are not old enough to understand how logical <i>if/thens</i> work and are still learning how their behavior can cause other things to happen.',
      id: 2,
      clicked: false,
      title: 'Logical If/Then Statements',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Distraction</h3>Distraction is a useful strategy for children at many different developmental stages. It works for kids who don’t talk yet and for those who speak in sentences. It’s especially helpful for young children with short attention spans because they can be easily redirected to prevent tantrums, whining, or problem behaviors.',
      id: 3,
      clicked: false,
      title: 'Distraction',
      missed: false,
    },
  ],
  [
    {
      content:
        '<h3>Developmental Tip: Is Your Child Ready For Time-Outs?</h3>Time-outs are not recommended for children under 2 years old. They work best when a child can follow simple directions like “pick up the toy” almost every time. Even if your child isn’t ready yet, it’s still useful to learn about time-outs so you can use them later or share the information with others. Until then, keep using the other strategies you’ve learned to manage misbehavior.',
      id: 1,
      clicked: false,
      title: 'Is Your Child Ready For Time-Outs',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Time-Out - 1</h3>Keep it simple and be clear and calm! For example, if your child is teasing, tell them, “If you continue to tease your brother, then you will need take a time-out.” ',
      id: 2,
      clicked: false,
      title: 'Time-Out - 1',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Time-Out - 2</h3>The point of time-out is to stop misbehavior immediately. If your child has a short attention span, you can use shorter periods of time. You can also keep track of the time with a kitchen timer or alarm on your phone. Let your child know you are starting the time. It is sometimes helpful if they can see the timer too! ',
      id: 3,
      clicked: false,
      title: 'Time-Out - 2',
      missed: false,
    },
  ],
  [
    {
      content:
        '<h3>About Developmental Tips for Module 6</h3><p>These tips focus on common stresses parents may experience related to worries about a child’s health, development, or behavior. Past medical experiences or ongoing concerns can make parents feel extra protective, struggle to set limits, or feel less connected to their child or family. The strategies in this module are designed to help parents manage these stresses.</p><br/><p>As you learn the stress-reduction strategies, think about how you can use them to handle the situations that cause you stress.</p>',
      id: 1,
      clicked: false,
      title: 'Tips for Module 6',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Take 5 Breathing Exercise</h3><p>Appointments and therapy sessions can be stressful. When you or your child feel overwhelmed, try the Take 5 breathing exercise together to help calm down.</p><br/><p>See the handout below to review the Take 5 breathing exercise.</p>',
      id: 2,
      clicked: false,
      title: 'Take 5 Breathing Exercise',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Time-Out for Parents</h3>Parenting a child with developmental or behavioral challenges can sometimes be an emotional rollercoaster. Some children with developmental or behavioral challenges might have difficulty controlling their behaviors and emotions and look to you for clues about how to behave and to emotionally calm themselves. If you are feeling particularly stressed or overwhelmed with the demands of your child, take some time for yourself, a parent time-out. Sometimes it only needs to be a short time like a quick trip to another room or sometimes a bit longer like a trip to the grocery store by yourself after finding another adult to watch your child. The more you are in control of your behaviors and emotions, the more you can help your child.',
      id: 3,
      clicked: false,
      title: 'Time-Out for Parents',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Reframing</h3><p>Sometimes parents link challenging behavior to past experiences, which can make the behavior feel more stressful. Reframing your thoughts and using supportive parenting strategies can help. Here’s an example.</p><p><strong>Stressful Behavior:</strong> A 3-year-old child who was born premature, cries or whines during therapy exercises.</p><p><strong>Upsetting Thought:</strong> “They went through so much in the NICU, I can’t make them go through this too.”</p><p><strong>Common Response:</strong> Stopping the exercise or not practicing</p><p><strong>Reframed Thought:</strong> “This is hard, but it’s important. I can help my child learn they can do hard things and be okay.”</p><p><strong>New Response:</strong> Use routines and gentle distractions, such as favorite songs, to comfort and support the child.</p>',
      id: 4,
      clicked: false,
      title: 'Reframing',
      missed: false,
    },
    {
      content:
        '<h3>Developmental Tip: Affirmations</h3><p>Parenting can be especially stressful if your child is having health, developmental, or behavioral challenges. Here are some affirmations that might be useful:</p><ul><li>No matter how scary, I have supported my child through all of their medical treatments.</li><li>I love my child, no matter what challenges they may face.</li><li>Even though they may take a little longer, my child is achieving milestones.</li><li>I am strong and so is my child; I see my child’s strength.</li><li>I am someone who will rise to do whatever is needed to help my child.</li><li>I am the expert on my child, everything they have been through, and what they need.</li></ul>',
      id: 5,
      clicked: false,
      title: 'Affirmations',
      missed: false,
    },
  ],
];

export default allTips;
